import React from 'react';
import { useEffect, useState, useRef } from "react";

import { useApp } from '../../context/AppContext.jsx';
import { useTranslation } from "react-i18next";
import { AboutPage } from './AboutPage.jsx';
import { UpdateHistory } from './UpdateHistory.jsx';
import { PrivacyPolicyPage } from './PrivacyPolicy.jsx';
import { SupportForm } from './SupportForm.jsx';

export const OptionPage = () =>
{
	const { t } = useTranslation();

	const MenuList = [
		{ id: "Option_About", getMenu: () => {return <AboutPage />} },
		{ id: "Option_UpdateHistory", getMenu: () => {return <UpdateHistory />} },
		{ id: "Option_PrivacyPolicy", getMenu: () => {return <PrivacyPolicyPage />} },
		{ id: "Option_SupportForm", getMenu: () => {return <SupportForm />} },
	];
	const [menu, setMenu] = useState(MenuList[0]);

	return (
		<div className="container-fluid h-100 p-0">
			<div className="row g-0 h-100">
				{/* 左列：一覧 */}
				<div className="col-3 d-flex flex-column h-100 p-1">
					<div className="p-1 h-100 my-bg-menu rounded p-1">
						<div className="h-100 rounded" style={{ overflowY: "auto" }}>
							<div className="list-group list-group-flush">
								{MenuList.map((item, index) =>
									<button
										key={index}
										className={`list-group-item p-1 small list-group-item-action ${(menu.id==item.id) ? 'active':''}`}
										onClick={() => setMenu(item)}
									>
										{t(item.id)}
									</button>
								)}
							</div>
						</div>
					</div>
				</div>
				{/* 右列 */}
				<div className="col-9 d-flex flex-column h-100">
					<div
						className="h-100 d-flex flex-column"
						style={{ overflowY: "auto" }}
					>
						{menu.getMenu()}
					</div>
				</div>
			</div>
		</div>
	);
};
